define('context',['module'], function(module){
    return module.config();
});
